<template>
    <BaseModal
        :isVisible="modalStatus"
        title="Check-List do Veículo"
        size="xl"
        @close="close"
    >
        <template v-slot:content>
            <!-- Header com informações do veículo -->
            <VehicleHeader
                :vehicle-data="reserve"
                @open-user-modal="openUserModal"
                :show-button-user="showButtonUser"
            />

            <!-- Navegação por abas -->
            <ul
                class="nav nav-tabs nav-fill tab-navigation"
                id="checkTabs"
                role="tablist"
            >
                <li class="nav-item">
                    <a
                        class="nav-link active"
                        id="checkout-tab"
                        data-toggle="tab"
                        href="#checkout-content"
                        role="tab"
                        aria-controls="checkout-content"
                        aria-selected="true"
                    >
                        <i class="fas fa-sign-out-alt mr-2"></i> Check-Out
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        id="checkin-tab"
                        data-toggle="tab"
                        href="#checkin-content"
                        role="tab"
                        aria-controls="checkin-content"
                        aria-selected="false"
                    >
                        <i class="fas fa-sign-in-alt mr-2"></i> Check-In
                    </a>
                </li>
            </ul>

            <div class="tab-content p-3 border border-top-0 rounded-bottom bg-white" id="checkTabsContent">
                <!-- Aba de Check-Out -->
                <div
                    class="tab-pane fade show active"
                    id="checkout-content"
                    role="tabpanel"
                    aria-labelledby="checkout-tab"
                >
                    <CheckForm
                        v-if="reserve && reserve.checkout"
                        :check-data="reserve.checkout"
                        :checklist-items="checklist_items"
                        check-type="checkout"
                        @open-lightbox="openLightbox"
                    />

                    <div v-else class="no-data-container">
                        <i class="fas fa-exclamation-circle text-warning"></i>
                        <p>Informações de Check-Out não disponíveis.</p>
                    </div>
                </div>

                <!-- Aba de Check-In -->
                <div
                    class="tab-pane fade"
                    id="checkin-content"
                    role="tabpanel"
                    aria-labelledby="checkin-tab"
                >
                    <CheckForm
                        v-if="reserve && reserve.checkin && reserve.reserve_status && reserve.reserve_status.id == '5'"
                        :check-data="reserve.checkin"
                        :checklist-items="checklist_items"
                        check-type="checkin"
                        @open-lightbox="openLightbox"
                    />

                    <div
                        v-else
                        class="no-data-container"
                    >
                        <i class="fas fa-info-circle text-info"></i>
                        <p>Check-In não realizado.</p>
                        <p class="sub-info">
                            Devolução estimada para:
                            <span class="date-highlight">{{ reserve ? reserve.devolution_date : 'N/A' }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from "../../Base/BaseModal.vue";
import VehicleHeader from "../../Modals/Checklist/VehicleHeader.vue";
import CheckForm from "../../Modals/Checklist/CheckForm.vue";
export default {
    components: {
        BaseModal,
        VehicleHeader,
        CheckForm
    },
    props: {
        modalStatus: { // modalStatus - status se modal está aberto ou fechado
            type: Boolean,
            default: false
        },
        reserve: { // reserve - dados da reserva
            type: Object,
            required: true
        },
        showButtonUser: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            checklist_items: [], // checklist_items - itens do checklist
        };
    },
    methods: {
        openLightbox(imgs) { // openLightbox - abre visualizador de imagens
            this.$emit("open-lightbox", imgs);
        },
        openUserModal() { // openUserModal - abre modal com dados do usuário
            this.$emit("open-user-modal", this.reserve);
        },
        close() { // close - fecha o modal
            this.$emit("close");
        },
        getChecklistItens() { // getChecklistItens - busca itens do checklist da API
            const self = this;
            const api = self.$store.state.api + "checklistItems?status=1";

            self.$http
                .get(api)
                .then((response) => {
                    self.checklist_items = response.data.data;
                })
                .catch((error) => {
                    console.error("Erro ao buscar itens do checklist:", error);
                });
        }
    },
    mounted() {
        this.getChecklistItens();
    }
};
</script>

<style scoped>
/* Navegação por abas */
.tab-navigation {
    margin-top: 20px;
    border-bottom: none;
}

.tab-navigation .nav-link {
    color: #6c757d;
    font-weight: 500;
    border: 1px solid #e2e8f0;
    border-bottom: none;
    border-radius: 8px 8px 0 0;
    padding: 12px 20px;
    transition: all 0.3s ease;
}

.tab-navigation .nav-link.active {
    color: white;
    background-color: #f8981d;
    border-color: #f8981d;
}

.tab-navigation .nav-link i {
    margin-right: 6px;
}

/* Mensagem para dados não disponíveis */
.no-data-container {
    text-align: center;
    padding: 60px 20px;
    background-color: #f8f9fa;
    border-radius: 8px;
    margin: 20px 0;
}

.no-data-container i {
    font-size: 48px;
    margin-bottom: 15px;
}

.no-data-container p {
    margin-bottom: 5px;
    font-size: 16px;
    color: #495057;
}

.sub-info {
    color: #6c757d;
    font-size: 14px;
}

.date-highlight {
    font-weight: bold;
    color: #f8981d;
}

/* Responsividade */
@media (max-width: 768px) {
    .tab-navigation .nav-link {
        padding: 10px 15px;
        font-size: 14px;
    }

    .no-data-container {
        padding: 40px 15px;
    }

    .no-data-container i {
        font-size: 36px;
    }

    .no-data-container p {
        font-size: 14px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ReserveVehicles/view-components/ViewModalCheckIn.vue